(function ($, helper) {

    var $document = $(document),
        infoButtonSelector = ".u-button--toggle",
        expandedClass = "u-button--expanded";

    if (helper.isMobile()) {
        $document.on("click", function (e) {
            var $button = $(".u-button--toggle");

            if ($button[0] !== e.target) {
                $button.removeClass(expandedClass);
            }
        });
        $document.on("click", infoButtonSelector, function (e) {
            var $button = $(e.target);

            if (!$button.hasClass(expandedClass)) {
                e.preventDefault();
                $button.addClass(expandedClass);
            }
        });
    } else {
        $document.on("mouseenter", infoButtonSelector, function () {
            $(this).addClass(expandedClass);
        });

        $document.on("mouseleave", infoButtonSelector, function () {
            $(this).removeClass(expandedClass);
        });

        $document.on("focus", infoButtonSelector, function () {
            $(this).addClass(expandedClass);
        });

        $document.on("blur", infoButtonSelector, function () {
            $(this).removeClass(expandedClass);
        });

        $document.on("keyup", function (e) {
            var $infoButton = $(infoButtonSelector);

            if (e.key === "Escape" && $infoButton.is(":focus")) {
                $infoButton.removeClass(expandedClass);
            }
        });
    }
})(window.jQuery, window.kfwHelper);
